import { setCasLanguageTokens } from 'utils/languageTokens/languageTokens';

(async () => {
  await setCasLanguageTokens();
  await import('./index');
})();
